var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_item_title"},[_c('div',{staticClass:"title_left"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"title_right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }